import type { TopGiftColumnId } from "@/interfaces/reportsTopGifts";

/** Fixed column arrangement — no ColumnConfigPopover, no user preferences. */
export const COLUMN_ORDER: TopGiftColumnId[] = ["rank", "product", "cause", "redemptions", "pct"];

/** Column id -> header label — used for the table header. */
export const COLUMN_LABELS: Record<TopGiftColumnId, string> = {
  rank: "Rank",
  product: "Product",
  cause: "Cause",
  redemptions: "Redemptions",
  pct: "% of Redemptions",
};

/** Decimal places shown on the `% of Redemptions` column. */
export const PCT_DECIMALS = 1;

/** Product thumbnail rendered edge length, in pixels. */
export const THUMBNAIL_SIZE = 40;

/** Table minimum width before horizontal scroll. */
export const MIN_WIDTH = 720;

/** The screen's user-facing strings, in one place so a wording change is one edit. */
export const TOP_GIFTS_TEXT = {
  allCampaigns: "All Campaigns",
  campaignsSelected: (n: number) => `${n} campaign${n === 1 ? "" : "s"}`,
  campaignMenuAria: "Filter by campaign",
  periodMenuAria: "Filter by period",
  /** The period is read in New York days (the API's BUSINESS_TIMEZONE); shown beside an active window. */
  periodZone: "(ET)",
  campaignMenuLoading: "Loading campaigns…",
  campaignMenuEmpty: "No campaigns with redemptions yet.",
  exportCsv: "Export CSV",
  csvFilename: "top-gifts.csv",
  emptyMessage: "No gift redemptions match these filters.",
  listError: "We couldn't load top gifts. Check your connection and try again.",
  retry: "Retry",
  countLabel: (gifts: number, redemptions: number) =>
    `${gifts} gift${gifts === 1 ? "" : "s"} · ${redemptions} redemption${redemptions === 1 ? "" : "s"}`,
} as const;
